import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { SubmitResult } from 'features/Project/pages';
import PropTypes from 'prop-types';

function SubmitResultPage({ isLiquidation }) {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <SubmitResult isLiquidation={isLiquidation} />
      </Layout>
    </LayoutProvider>
  );
}

SubmitResultPage.propTypes = {
  isLiquidation: PropTypes.bool,
};

SubmitResultPage.defaultProps = {
  isLiquidation: false,
};

export default SubmitResultPage;
